module.exports = __webpack_public_path__ + "img/icon-red-star.d1083375.svg";